import { useEffect, useState } from "react";
import { CorporateCard } from "../../components/Card/CorporateCard";
import BookingDataService from "../../services/Booking";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";

export const CorporateList = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const navigate = useNavigate();
  const toast = useToast();
  const [list, setList] = useState([]);

  const fetchData = () => {
    BookingDataService.getCorporatesDetails(token)
      .then((res) => {
        setList(res.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };
  useEffect(()=>{
    fetchData()
  },[])

  return (
    <div>
      <div className="page_title py-2">Corporate</div>

      <div className="corporate-grid-container">
        {list.map((el: any) => (
          <CorporateCard key={el._id} {...el} />
        ))}
      </div>
    </div>
  );
};
